import type { ClickAction, SceneElement } from '../../types';

export type OpenSceneInEditorHandler = (sceneId: string, elementId?: string) => void;

const ELEMENT_TYPE_ICONS: Record<SceneElement['type'], string> = {
  character: '🎭',
  object: '🖼️',
  hotspot: '👆',
  text: '📝',
  mailbox: '📬',
};

export function assetBasename(path?: string): string | null {
  if (!path?.trim()) return null;
  const parts = path.split('/');
  return parts[parts.length - 1] ?? path;
}

export function summarizeClickAction(action?: ClickAction): string | null {
  if (!action) return null;

  switch (action.type) {
    case 'goto': {
      const payload = action.payload as { sceneId?: string; scene?: string } | string | undefined;
      if (typeof payload === 'string') return `→ ${payload}`;
      const target = payload?.sceneId ?? payload?.scene;
      return target ? `→ ${target}` : '→ scène';
    }
    case 'dialogue':
      return 'dialogue';
    case 'collectItem':
      return 'collecte';
    case 'setFlag':
      return 'flag';
    case 'changeBackground':
      return 'fond';
    case 'showTextOverlay':
      return 'overlay';
    default:
      return action.type;
  }
}

export function getElementTypeIcon(type: SceneElement['type']): string {
  return ELEMENT_TYPE_ICONS[type] ?? '•';
}

export function getElementChipMeta(element: SceneElement): string[] {
  const meta: string[] = [element.type];

  const imageName = assetBasename(element.image);
  if (imageName) meta.push(imageName);

  if (element.pedaShields && element.pedaShields > 0) {
    meta.push(`${element.pedaShields} bouclier${element.pedaShields > 1 ? 's' : ''}`);
  } else if (element.inspectable === false) {
    meta.push('décor');
  }

  const actionHint = summarizeClickAction(element.clickAction);
  if (actionHint) meta.push(actionHint);

  return meta;
}
